export function createParagraphsFromBrs(content: string) {
  const replaced = content
    .replace(/^\s*(?:<br\s*\/?>\s*)*/i, "")
    .replace(/\s*(?:<br\s*\/?>\s*)*$/i, "")
    .replace(/(?:<br\s*\/?>\s*?){2,}/gi, "</p><p>");

  return `<p>${replaced}</p>`;
}

export function camelCase(dashString: string) {
  return dashString
    .replace(/-([a-z])/g, function (g) {
      return g[1].toUpperCase();
    });
}

export function dashCase(camelString: string) {
  return camelString.replace(/[A-Z]/g, m => "-" + m.toLowerCase());
}

export function abbreviateText(text, length) {
  if (text.length <= length) {
    return text;
  }

  var lastWhitespaceIndex = text.substring(0, length - 1).lastIndexOf(' ');

  if (lastWhitespaceIndex) {
    return text.substring(0, lastWhitespaceIndex) + '\u2026';
  } else {
    return text.substring(0, length - 1);
  }
}
